"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SEARCH_INPUT_ROOT_MOBILE = exports.SEARCH_INPUT_ROOT_DESKTOP = exports.SEARCH_INPUT_CLEAR = exports.SEARCH_INPUT_BOX_HEIGHT = exports.SEARCH_INPUT_BOX = exports.SEARCH_INPUT = exports.SEARCH = exports.BACKDROP = void 0;
const SEARCH_INPUT_ROOT_DESKTOP = exports.SEARCH_INPUT_ROOT_DESKTOP = 'search-input-root-desktop';
const SEARCH_INPUT_ROOT_MOBILE = exports.SEARCH_INPUT_ROOT_MOBILE = 'search-input-root-mobile';
const SEARCH_INPUT_BOX = exports.SEARCH_INPUT_BOX = 'search-input-box';
const SEARCH_INPUT = exports.SEARCH_INPUT = 'search-input';
const SEARCH = exports.SEARCH = 'search';
const SEARCH_INPUT_CLEAR = exports.SEARCH_INPUT_CLEAR = 'search-input-clear';
const BACKDROP = exports.BACKDROP = 'backdrop';
const SEARCH_INPUT_BOX_HEIGHT = exports.SEARCH_INPUT_BOX_HEIGHT = 44;
